enum TimberBambooPackaging {
  NO_PACKAGING = 'no_packaging',
  TIMBER = 'timber',
  BAMBOO = 'bamboo',
}
export default TimberBambooPackaging;
